// Determine WebSocket protocol
// const isSecure = process.env.REACT_APP_WEBSOCKET_SECURE === "true";
// const wsProtocol = isSecure ? "wss" : "ws";

// Export configuration
export const API_URL = `${process.env.REACT_APP_API_URL}/api`;
export const STORAGE_URL = process.env.REACT_APP_STORAGE_URL;
export const WEBSOCKET_URL = `${process.env.REACT_APP_DOMAIN}:${process.env.REACT_APP_WEBSOCKET_PORT}/my-websocket`;

// Google reCAPTCHA v2 site key. Leave empty to turn the captcha off in the UI.
export const RECAPTCHA_SITE_KEY = (process.env.REACT_APP_RECAPTCHA_SITE_KEY || "").trim();
export const RECAPTCHA_ENABLED = RECAPTCHA_SITE_KEY !== "";

// The business that runs this system, and how to reach it.
// Shown on the Privacy Policy and the Terms and Conditions.
export const BUSINESS_NAME = "Milk Stars Enterprises";
export const CONTACT_PHONE = "0716538962";
export const CONTACT_ADDRESS = "P.O. Box 1186 - 10200, Murang'a";

// 0716538962 -> 0716 538 962, the way it is read out.
export const CONTACT_PHONE_DISPLAY = CONTACT_PHONE.replace(/^(\d{4})(\d{3})(\d{3})$/, "$1 $2 $3");
// 0716538962 -> tel:+254716538962
export const CALL_URL = `tel:+${CONTACT_PHONE.replace(/^0/, "254")}`;
